import {Divider, Group, Paper, Stack, Text, Title} from '@mantine/core'

import {formatRelativeTime} from '../jobs/format-relative-time'
import type {DriverJob} from './schemas'

type DriverJobComment = DriverJob['comments'][number]

type DriverJobCommentsProps = {
    comments: DriverJobComment[]
}

export function DriverJobComments({comments}: DriverJobCommentsProps) {
    if (comments.length === 0) {
        return null
    }

    return (
        <Paper withBorder p="md" radius="md">
            <Stack gap="md">
                <Title order={4}>Comments</Title>
                <Stack gap="sm">
                    {comments.map((comment, index) => (
                        <Stack key={comment.id} gap="xs">
                            {index > 0 ? <Divider /> : null}
                            <Group gap="xs" align="baseline">
                                <Text size="sm" fw={700}>
                                    {comment.createdByName}
                                </Text>
                                <Text size="sm" c="dimmed">
                                    {formatRelativeTime(comment.createdAt)}
                                </Text>
                            </Group>
                            <Text size="sm">{comment.content}</Text>
                        </Stack>
                    ))}
                </Stack>
            </Stack>
        </Paper>
    )
}
